var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 16.5",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5,5.3H4v11.2H0.5V5.3z M2.1,3.9L2.1,3.9C1,4,0.1,3.2,0,2.1C0,2,0,2,0,1.9c-0.1-1.2,0.8-2.2,1.9-2.3 c1.2-0.1,2.2,0.8,2.3,1.9S3.5,3.8,2.3,3.9C2.3,3.9,2.2,3.9,2.1,3.9z M18,16.5h-4v-5.8c0-1.5-0.6-2.6-2-2.6c-0.9,0-1.6,0.6-1.9,1.4 C10,9.8,10,10.1,10,10.4v6.1H6.1c0,0,0.1-10.3,0-11.2H10v1.8c0.2-0.8,1.5-1.9,3.5-1.9c2.5,0,4.4,1.6,4.4,5.1L18,16.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.3ae0bbe1a98d1624737f8a314b92662d.svg";
export { ForwardRef as ReactComponent };